import { isActivityFieldPermitted } from "PFCore/helpers/activity_fields_permissions";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, FeatureFlag, Profile, Template } from "PFCore/types";

type UseIsBookingCategoryVisibleProps = {
  template: Template;
  activityCreator: Profile | null;
};

export const useIsBookingCategoryVisible = ({
  template,
  activityCreator
}: UseIsBookingCategoryVisibleProps) => {
  const { data: currentProfile } = useCurrentProfile();

  const isFeatureEnabled = useIsFeatureEnabled();
  const isBookingModuleEnabled = isFeatureEnabled(FeatureFlag.BookingModule);

  const isPermittedToSeeBookingCategoryField = isActivityFieldPermitted({
    currentProfile,
    activityCreator,
    fieldName: "booking_category",
    accessLevel: AccessLevel.ReadOnly
  });

  return (
    isBookingModuleEnabled &&
    !!template.schema.properties.booking_category_id &&
    isPermittedToSeeBookingCategoryField
  );
};
